import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { FOOTBALL_SCOUTING_CENTER_SO5_COMPETITION_SLUG } from 'constants/__generated__/routes';

const Root = styled(ButtonBase)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--unit);
  background-position: center;
  background-size: cover;
  height: 100%;
  width: 100%;
  transition: all ease-out 0.23s;
  border: 1px transparent;
  &:hover {
    border: 1px solid var(--c-nd-150);
    & img {
      transform: scale(1.1);
    }
  }
`;

const CompetitionLogo = styled.img`
  max-width: 116px;
  max-height: 56px;
  object-fit: contain;
  object-position: center;
  transition: ease-out 0.25s;

  .small & {
    max-width: 96px;
    max-height: 42px;
  }
`;

type Props = {
  so5Competition: {
    slug: string;
    logoUrl: string;
    backgroundUrl: string;
  };
  size?: 'small' | 'default';
  onClick?: () => void;
};

export const ScoutingCenterEntry = ({
  so5Competition,
  size = 'default',
  onClick,
}: Props) => {
  return (
    <Root
      className={size}
      onClick={onClick}
      to={generatePath(FOOTBALL_SCOUTING_CENTER_SO5_COMPETITION_SLUG, {
        slug: so5Competition.slug,
      })}
      style={{
        backgroundImage: `url(${so5Competition.backgroundUrl})`,
      }}
    >
      <CompetitionLogo src={so5Competition.logoUrl} />
    </Root>
  );
};
